import { useContext } from 'react';
import { DeviceSettingContext } from '../context/device-setting-context';
import { ErrorStateContext } from '../context/error-state-context';

const useErrorStateContext = () => {
  const context = useContext(ErrorStateContext);
  if (!context) {
    throw new Error('useErrorStateContext must be used within a ErrorStateContext');
  }
  return context;
};
export default useErrorStateContext;
